import { PromoteProductChildren } from '@/connection/content/products';
import { Product } from '@/types/module.types';
import { ContentReducerCreator } from '../types';

const promoteProductReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, product }: { channel: number; product: Product }) => {
      if (!product.module_id) throw new Error('module_id required');

      return await PromoteProductChildren(channel, [product.module_id]);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        if (state.products) {
          state.products = [...action.payload.products, ...state.products];
        }
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default promoteProductReducer;
